import jQuery from 'jquery';
import TH_JSFunction from '_loaders/JSFunction.js';
import TH_Translate from '_loaders/Translate.js';

class TH_PluginBase {
    constructor(main) {
        this.options = {};
        this.events = {};
        this.defaultTexts = {};
        this.functionOptions = [];
        this.dom = {
            main: jQuery(main)
        };
        this.inited = false;

        this.options = this.dom.main.data('plugin-options');
        if (typeof this.options.events != 'undefined') {
            this.events = this.options.events;
            delete this.options.events;
        }

        if (typeof this.options.defaultTexts != 'undefined') {
            this.defaultTexts = this.options.defaultTexts;
            delete this.options.defaultTexts;
        }


        this.__buildDom();
        this.__buildDefaultOptions();
        this.__buildDefaultEvents();
        this.__buildDefaultTexts();

        this.__init();

        this.__setListeners();

        this.dom.main.addClass('th-inited');
        this.dom.main.data('th-plugin', this);
    }

    /** Build a list with options that should be tried to be converted to a function from a JS Function
     * 
     */
    __buildFunctionOptions() {
        for (let i in this.functionOptions) {
            if (typeof this.options[this.functionOptions[i]] !== 'undefined' && typeof this.options[this.functionOptions[i]] != 'function') {
                this.options[this.functionOptions[i]] = JSFunction.create(this.options[this.functionOptions[i]], this);
                if (typeof this.options[this.functionOptions[i]] != 'function') delete this.options[this.functionOptions[i]];
            }
        }
    }

    /** Initialize the plugin - you should build this in your own instance, this will only set a flag to true
     * 
     */
    __init() {
        this.inited = true;
    }

    /** Build the default dom structure of this plugin - if you want to specify default or additional dom elements, override this function in your extended class
     *
     */
    __buildDom() {
        return this.dom;
    }

    /** Build the default options of this plugin - if you want to specify default events, override this function in your extended class
     * 
     */
    __buildDefaultOptions() {
        this.__buildFunctionOptions();
        return this.options;
    }

    /** Build the default events of this plugin - if you want to specify default events, override this function in your extended class
     * 
     */
    __buildDefaultEvents() {
        for (let eventName in this.events) {
            if (!Array.isArray(this.events[eventName])) this.events[eventName] = [this.events[eventName]]; 
            for (let eventFunction in this.events[eventName]) {
                if (typeof this.events[eventName][eventFunction] != 'function') {
                    this.events[eventName][eventFunction] = JSFunction.create(this.events[eventName][eventFunction], this);
                    if (typeof this.events[eventName][eventFunction] != 'function') delete this.events[eventName][eventFunction];
                }
            }

            if (this.events[eventName].length == 0) delete this.events[eventName];
        }
    }

    /** Set the default event listeners that should be used
     * 
     * @param jQuery target (the target elem that should be listening, by default, it will be the this.dom.main elem)
     * 
     */
    __setListeners(listenerData) {
        let selfRef = this;

        if (typeof listenerData == 'undefined' || !Array.isArray(listenerData)) {
            listenerData = [{
                target: this.dom.main,
                events: this.events
            }];
        }

        for (let listenerGroup in listenerData) {
            for (let eventName in listenerData[listenerGroup].events) {
                listenerData[listenerGroup].target.on(eventName, function() {
                    let originalArguments = Array.prototype.slice.call(arguments),
                        returnValue;
                        
                    for (event in listenerData[listenerGroup].events[eventName]) {
                        returnValue = listenerData[listenerGroup].events[eventName][event].apply({
                            original: this,
                            instance: selfRef
                        }, originalArguments);
                        if (typeof returnValue !== 'undefined') return returnValue;
                    }
                });
            }
        }
       
    }

    /** Build the default texts of this plugin - if you want to specify default texts, override this function in your extended class
     * 
     *  If you want to specify default texts, that this function should translate, to diferentiate them from the overwritten and translated default texts, provided
     *  by the back-end, put the javascript default texts in an array, instead of providing them as plain strings.
     * 
     */
    __buildDefaultTexts() {
        let tempArray;

        for (let i in this.defaultTexts) {
            if (Array.isArray(this.defaultTexts[i])) {
                tempArray = this.defaultTexts[i];
                this.defaultTexts[i] = Translate.text.apply(Translate, this.defaultTexts[i]);
                Translate.asyncText.apply(Translate, tempArray).then(function(text) {
                    this.defaultTexts[i] = text;
                }.bind(this));
            }
        }
        return this.defaultTexts;
    }

    /** Default error reporting for the plugin instance - you should make a specific error reporting in the extended versions of this class, that suits your
     *  project.
     * 
     * @param string error          (the error string to display)
     * @param string identifier     (an identifier, to further customize the error message, the default error reporter does not use this)
     * 
     */
    defaultErrorReporting(error, identifier) {
        console.error(error);
    }

    /** Initialize multiple instances of this plugin 
     * 
     */
    static initializeMultiple(definition, search) {
        jQuery(search + ":not(.th-inited)").each(function() {
            if (jQuery(this).hasClass('no-init')) return;

            new definition(jQuery(this));
        });
    }
}

export default TH_PluginBase;